import { StyleBreakpoints } from '@constants';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import React from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '12px',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    backgroundColor: '#fff',

    [theme.breakpoints.up(StyleBreakpoints.sm)]: {
      display: 'none'
    }
  },
  jumpText: {
    fontWeight: 700,
    fontSize: 14,
    marginLeft: 12,
    flex: 2,
    marginRight: 20
  },
  jumpButton: {
    borderRadius: '12px',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '16px',
    textTransform: 'none',
    flex: 8
  },
  jumpButtonBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    fontSize: 14
  },
  jumpButtonIcon: {
    width: 20,
    height: 20
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    fontSize: '14px',
    fontWeight: 700,
    gap: '36px'
  },
  menuPaper: {
    borderRadius: '12px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    marginTop: '10px',
    marginRight: '4px',
    padding: '8px 12px'
  },
  icon: {
    fontSize: '24px'
  }
}));

const JumpMenu = ({ tabsInfo }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedItem, setSelectedItem] = React.useState(tabsInfo?.[0]);
  const buttonRef = React.useRef(null);
  const classes = useStyles();
  const intl = useIntl();
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectItem = item => {
    setSelectedItem(item);
    const targetBox = document.getElementById(item.name);

    if (targetBox) {
      targetBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    handleClose();
  };

  if (!tabsInfo?.length) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={`${classes.jumpText} text-slate-800`}>
        {intl.formatMessage(messages.jumpTo)}:
      </div>
      <Button
        ref={buttonRef}
        className={`${classes.jumpButton} !bg-slate-100 hover:!bg-slate-200 !text-slate-700 transition-colors ${
          open ? '!border !border-solid !border-indigo-500' : ''
        }`}
        id="jump-button"
        aria-controls={open ? 'jump-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}>
        <div className={classes.jumpButtonBox}>
          <img src={selectedItem?.icon} className={classes.jumpButtonIcon} alt="Icon" />
          <div>{selectedItem?.label}</div>
        </div>
        {open ? (
          <KeyboardArrowUp className={`${classes.icon} text-slate-400`} />
        ) : (
          <KeyboardArrowDown className={`${classes.icon} text-slate-400`} />
        )}
      </Button>
      <Menu
        id="jump-menu"
        anchorEl={anchorEl}
        open={open}
        classes={{ paper: classes.menuPaper }}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        getContentAnchorEl={null}
        PaperProps={{
          style: {
            width: buttonRef.current ? buttonRef.current.offsetWidth : null
          }
        }}
        MenuListProps={{
          'aria-labelledby': 'jump-button'
        }}>
        {tabsInfo.map((tabInfo, key) => {
          return (
            <MenuItem
              button
              key={key}
              className={`${classes.menuItem} ${
                tabInfo.name === selectedItem?.name
                  ? '!bg-indigo-50 !text-indigo-700 rounded-lg'
                  : '!text-slate-700'
              }`}
              onClick={() => handleSelectItem(tabInfo)}>
              <img src={tabInfo.icon} width={22} alt={tabInfo.label} />
              <div>{tabInfo.label}</div>
              {tabInfo.isBetaFeature && (
                <div className="absolute right-5 inline-flex items-center bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-md text-[10px] font-bold border border-solid border-indigo-200/55">
                  Beta
                </div>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default JumpMenu;
